export default __webpack_public_path__ + "static/media/illustration_step3_howItWorks.ee9d4462.png";